export default __webpack_public_path__ + "static/floatingImg1-ae68c0c8629151670d0d46054dbe48e5.webp";